import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'

export const accountSettingsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: routes.bank.settings,
    component: lazyRouteComponent(() => import('./AccountSettings'))
  })
